import { render } from "./TokenRequest.vue?vue&type=template&id=1c12f34c&scoped=true"
import script from "./TokenRequest.vue?vue&type=script&lang=js"
export * from "./TokenRequest.vue?vue&type=script&lang=js"

import "./TokenRequest.vue?vue&type=style&index=0&id=1c12f34c&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c12f34c"]])

export default __exports__